<script setup lang="ts">
import ColorBadge from "@/components/ui/ColorBadge.vue";
import TextInput from "@/components/ui/TextInput.vue";

const props = defineProps<{
  close: (result: unknown) => void;
  cancel: () => void;
}>();

const name = defineModel<string>("name", { default: "" });
</script>

<template>
  <div class="create-api-key-modal-body">
    <TextInput
      v-model="name"
      placeholder="Key Name"
      label="Key Name"
      :focus="true"
      @keyup.enter="props.close(name)"
      help-text="Please provide a descriptive name for your new API key. This name is for your reference only."
    />

    <ColorBadge color="blue" left-icon="icon-info-circle-2">
      Please make sure the key is saved on a secure storage. For security purposes, the key can only
      be displayed once.
    </ColorBadge>
  </div>
</template>

<style scoped>
.create-api-key-modal-body {
  display: flex;
  flex-direction: column;
  gap: var(--numbers-16);
}
</style>
